// extracted by mini-css-extract-plugin
module.exports = {"root":"LoggedInLayoutBasic_root__2cNaj","scrollableY":"LoggedInLayoutBasic_scrollableY___i-4A"};